import { render } from "./SiteHeaderLink.vue?vue&type=template&id=c3d9f7da&ts=true"
import script from "./SiteHeaderLink.vue?vue&type=script&lang=ts"
export * from "./SiteHeaderLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__